/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BUSINESS_BOOKER_USER_ROLES, LOCALES } from '@whitbread-eos/api';
import { getPathForLocale } from '@whitbread-eos/utils';
import { formatIBAssetsUrl, getLocaleByPathname, useTranslation } from '@whitbread-eos/utils/server';
import { usePathname } from 'next/navigation';
import SidebarLink from '../SidebarLink/SidebarLink.component';
const FirstLevelNav = ({ userRole, isAccountHolder, isCollapsed = false, menuLabels, onManageClick, isMobile = false })=>{
    const baseDataTestId = 'FirstLevelNav';
    const pathname = usePathname();
    const locale = getLocaleByPathname(pathname);
    const { t } = useTranslation();
    const { home, spending, manage, bookings } = menuLabels;
    const country = locale === LOCALES.EN ? 'gb' : 'de';
    const language = locale === LOCALES.EN ? 'en' : 'de';
    var _home_icon, _home_iconActive, _spending_icon, _spending_iconActive, _manage_icon, _manage_iconActive, _bookings_icon, _bookings_iconActive;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": `${baseDataTestId}-container`,
        className: `${navBaseStyle} ${isCollapsed ? navCollapsedStyle : navExpandedStyle}`,
        children: [
            /*#__PURE__*/ _jsx(SidebarLink, {
                label: t('layout.menu.home.label'),
                icon: formatIBAssetsUrl((_home_icon = home === null || home === void 0 ? void 0 : home.icon) !== null && _home_icon !== void 0 ? _home_icon : ''),
                iconActive: formatIBAssetsUrl((_home_iconActive = home === null || home === void 0 ? void 0 : home.iconActive) !== null && _home_iconActive !== void 0 ? _home_iconActive : ''),
                isActive: pathname.includes('homepage'),
                isCollapsed: isCollapsed,
                href: getPathForLocale(locale, 'homepage'),
                mainStyle: true,
                testId: "Home"
            }),
            /*#__PURE__*/ _jsx(SidebarLink, {
                label: t('layout.menu.spending.label'),
                icon: formatIBAssetsUrl((_spending_icon = spending === null || spending === void 0 ? void 0 : spending.icon) !== null && _spending_icon !== void 0 ? _spending_icon : ''),
                iconActive: formatIBAssetsUrl((_spending_iconActive = spending === null || spending === void 0 ? void 0 : spending.iconActive) !== null && _spending_iconActive !== void 0 ? _spending_iconActive : ''),
                isActive: pathname.includes('spending'),
                isCollapsed: isCollapsed,
                href: getPathForLocale(locale, 'spending'),
                mainStyle: true,
                testId: "Spending"
            }),
            (userRole === BUSINESS_BOOKER_USER_ROLES.SUPER || isAccountHolder) && /*#__PURE__*/ _jsx(SidebarLink, {
                label: t('layout.menu.manage.label'),
                icon: formatIBAssetsUrl((_manage_icon = manage === null || manage === void 0 ? void 0 : manage.icon) !== null && _manage_icon !== void 0 ? _manage_icon : ''),
                iconActive: formatIBAssetsUrl((_manage_iconActive = manage === null || manage === void 0 ? void 0 : manage.iconActive) !== null && _manage_iconActive !== void 0 ? _manage_iconActive : ''),
                isActive: pathname.includes('manage'),
                isCollapsed: isCollapsed,
                href: getPathForLocale(locale, 'manage/employees'),
                onClick: onManageClick,
                mainStyle: true,
                testId: "Manage",
                isButton: isMobile
            }),
            /*#__PURE__*/ _jsx(SidebarLink, {
                label: t('layout.menu.bookings.label'),
                icon: formatIBAssetsUrl((_bookings_icon = bookings === null || bookings === void 0 ? void 0 : bookings.icon) !== null && _bookings_icon !== void 0 ? _bookings_icon : ''),
                iconActive: formatIBAssetsUrl((_bookings_iconActive = bookings === null || bookings === void 0 ? void 0 : bookings.iconActive) !== null && _bookings_iconActive !== void 0 ? _bookings_iconActive : ''),
                isActive: pathname.includes('account/dashboard'),
                isCollapsed: isCollapsed,
                href: `/${country}/${language}/business-booker/account/dashboard.html`,
                mainStyle: true,
                testId: "Bookings"
            })
        ]
    });
};
export default FirstLevelNav;
const navBaseStyle = 'flex flex-col gap-2 mobile:gap-1 mobile:flex-row mobile:w-full mobile:justify-between mobile:w-auto';
const navExpandedStyle = 'w-[11.375rem]';
const navCollapsedStyle = 'w-14 mobile:hidden';
